import { GridCellProps } from "@progress/kendo-react-grid";
import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { FoldedUnfoldedDropdownCell } from "../../../Layout/Grid/Cell/FoldedUnfoldedDropdownCell";
import { RC2DropdownCell } from "../../../Layout/Grid/Cell/RC2DropdownCell";
import { ScopeDropdownCell } from "../../../Layout/Grid/Cell/ScopeDropdownCell";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { PdsrValidationItem } from "./PdsrValidationItem";
import { MaxStockQuantityCell } from "./CustomCells/MaxStockQuantityCell";
import { updateModeColumnMenu, UpdateModeEnumCell } from "./CustomCells/UpdateModeEnumCell";
import { PdsrValidationItemEditMode as EditMode } from "./PdsrValidationItemGrid";
import { YesNoColumnMenu } from "../../../Layout/Grid/Filter/YesNoColumnMenu";
import { InScopeOutOfScopeColumnMenu } from "../../../Layout/Grid/Filter/InScopeOutOfScopeColumnMenu";
import { FoldedUnfoldedColumnMenu } from "../../../Layout/Grid/Filter/FoldedUnfoldedColumnMenu";
import { UppercaseCell } from "../../../Grid/UppercaseCell";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

type Props = {
  editMode: EditMode;
};

export default function PdsrValidationItemGridColumns({
  editMode,
  onRowClick,
  isReadOnly,
}: Props & GridRowClickProps & ReadOnlyProps) {
  const foldedUnfoldedEditable = true;
  const foldedUnfoldedDropdownCell = (props: GridCellProps) =>
    FoldedUnfoldedDropdownCell({
      ...props,
      editable: foldedUnfoldedEditable,
      onRowClick,
      isReadOnly,
    });

  const updateModeEnumCell = (props: GridCellProps) =>
    UpdateModeEnumCell({
      ...props,
      onRowClick,
    });
  const scopeDropdownCell = (props: GridCellProps) =>
    ScopeDropdownCell({
      ...props,
      onRowClick,
      isReadOnly,
    });
  const rc2DropdownCell = (props: GridCellProps) =>
    RC2DropdownCell({
      ...props,
      onRowClick,
      isReadOnly,
    });

  const maxStockQuantityCell = (props: GridCellProps) => {
    return MaxStockQuantityCell({
      ...props,
      isReadOnly,
    });
  };

  const uppercaseCell = ({ ...props }: GridCellProps) => {
    return UppercaseCell({
      ...props,
      isReadOnly,
    });
  };

  return [
    columnForField<PdsrValidationItem>("ImportDate", {
      title: "Import Date",
      filter: "date",
      cell: kendoDateCell(onRowClick),
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("ContainerNetwork", {
      title: "Container Network",
      editable: editMode === EditMode.Create,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("SupplierGsdb", {
      title: "Supplier",
      editable: editMode === EditMode.Create,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("PlantGsdb", {
      title: "Plant",
      editable: editMode === EditMode.Create,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("InboundDock", {
      title: "Inbound Dock",
      editable: editMode === EditMode.Create,
      cell: uppercaseCell,
      resizable: true,
      width: "150px",
    }),
    columnForField<PdsrValidationItem>("ContainerType", {
      title: "Container Type",
      editable: editMode === EditMode.Create,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("FoldedFlag", {
      title: "Folded/Unfolded",
      editable: foldedUnfoldedEditable,
      resizable: true,
      hideFilterCell: true,
      columnMenu: FoldedUnfoldedColumnMenu,
      cell: foldedUnfoldedDropdownCell,
      width: "150px",
    }),
    columnForField<PdsrValidationItem>("OutboundDock", {
      title: "Outbound Dock",
      editable: true,
      cell: uppercaseCell,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("Rc2Flag", {
      title: "Limited Pool Size",
      editable: true,
      hideFilterCell: true,
      columnMenu: YesNoColumnMenu,
      cell: rc2DropdownCell,
      resizable: true,
      width: "150px",
    }),
    columnForField<PdsrValidationItem>("MaxStockQuantity", {
      title: "Max Stock Quantity",
      filter: "numeric",
      cell: maxStockQuantityCell,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("InScope", {
      title: "Scope",
      editable: true,
      hideFilterCell: true,
      columnMenu: InScopeOutOfScopeColumnMenu,
      cell: scopeDropdownCell,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("FirstCollectionDate", {
      title: "First Collection",
      filter: "date",
      cell: kendoDateCell(onRowClick),
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("UpdateMode", {
      title: "Update Mode",
      hideFilterCell: true,
      columnMenu: updateModeColumnMenu,
      cell: updateModeEnumCell,
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("LastModifiedUser", {
      title: "Last Modified By",
      resizable: true,
      width: defaultColumnWidth,
    }),
    columnForField<PdsrValidationItem>("LastModifiedDateTime", {
      title: "Last Modified",
      filter: "date",
      cell: kendoDateCell(onRowClick),
      resizable: true,
      width: defaultColumnWidth,
    }),
  ];
}
